module.exports = __webpack_public_path__ + "media/images/strategic-partners/new/SmartHeart-2755b713d7f89446532025922eed9a03.png";